import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import { State } from './errorReducer';

const useError = () => {
  const currentCaseData = useSelector((state: RootState) => {
    return state.casePepperError as State;
  });
  return currentCaseData.error;
};

export default useError;
